import { all, call, cancelled, put, spawn, takeLatest } from 'redux-saga/effects';
import actions from './actions';
import fetchListsGraphql, { fetchCandidateSearchListsGraphql } from './graphql';

function* fetchListsGenerator() {
  try {
    const response = yield call(fetchListsGraphql);
    yield put({
      type: actions.FETCH_LISTS_DONE,
      payload: response.data.lists,
    });
  } catch (e) {
    log(e);
    yield put({ type: actions.FETCH_LISTS_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_LISTS_CANCELLED,
      });
    }
  }
}

function* fetchCandidateSearchListsGenerator() {
  try {
    const response = yield call(fetchCandidateSearchListsGraphql);
    yield put({
      type: actions.FETCH_CANDIDATE_SEARCH_LISTS_DONE,
      payload: response.data.lists,
    });
  } catch (e) {
    log(e);
    yield put({ type: actions.FETCH_CANDIDATE_SEARCH_LISTS_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_CANDIDATE_SEARCH_LISTS_CANCELLED,
      });
    }
  }
}

export function* fetchLists() {
  yield takeLatest(actions.FETCH_LISTS_START, fetchListsGenerator);
}

export function* fetchCandidateSearchLists() {
  yield takeLatest(actions.FETCH_CANDIDATE_SEARCH_LISTS_START, fetchCandidateSearchListsGenerator);
}

export default function* rootSaga() {
  yield all([spawn(fetchLists), spawn(fetchCandidateSearchLists)]);
}
